import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'containers/App/actions';
import { ChecklistComponent } from 'components/NCCheckList/Checklist';

const ProjectTaskList = ({ data }) => {
  const [activeTaskIndex, setActiveTask] = useState(-1);
  const dispatch = useDispatch();
  let projects = JSON.parse(JSON.stringify(data));
  projects = Array.isArray(projects) ? projects: Object.values(projects);

  const fullProjects = projects
    ?.filter(project => project.tasks?.length > 0)
    .sort((item1, item2) => item1.name?.localeCompare(item2.name));
  const emptyProjects = projects
    ?.filter(project => !project.tasks?.length)
    .sort((item1, item2) => item1.name?.localeCompare(item2.name));
  projects = fullProjects.concat(emptyProjects);

  const { createNotificationTask } = bindActionCreators(actions, dispatch);

  const createTask = (weddingId, tasks) => {
    const variables = {
      module: 'weddings',
      weddingId,
      input: {},
      referenceId: tasks.length > 0 ? tasks[0].id : null,
    };

    if (variables) {
      createNotificationTask({ variables });
      setActiveTask(0);
    }
  };

  return (
    <>
      {projects?.map(({ id, name, organizationId, tasks, assignmentOptions }) => (
        <div
          name="checklist"
          key={id}
        >
          <div name="headers">
            <div name="controls">
              <button
                className="APIconButton"
                name="add"
                onClick={() => createTask(id, tasks)}
              >
                +
              </button>
            </div>
            <h2
              name="name"
              className="heading-section"
            >
              {name?.toUpperCase()}
            </h2>
            {!tasks.length && (
              <div name="empty">You have no assigned tasks for this project.</div>
            )}
          </div>
          <ChecklistComponent
            tasks={tasks}
            weddingId={id}
            organizationId={organizationId}
            assignmentOptions={assignmentOptions}
            module="weddings"
            active={activeTaskIndex}
            setActive={setActiveTask}
          />
        </div>
      ))}
    </>
  );
};

export default ProjectTaskList;
